import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'split-tooltip-text',
  templateUrl: './split-tooltip-text.component.html',
  styleUrls: ['./split-tooltip-text.component.scss']
})
export class SplitTooltipTextComponent {
  @Input({ required: true }) text: string = "";
  @Input() tooltipText: string | TemplateRef<any> = "";
}
